<script>
export default {
  name: "NewGame",
  data() {
    return {
      opacity: 0,
      visible: false,
      hasMoreCosmetics: false,
      selectedSetName: "",
    };
  },
  computed: {
    style() {
      return {
        opacity: this.opacity,
        visibility: this.visible ? "visible" : "hidden",
      };
    }
  },
  methods: {
    update() {
      this.visible = GameEnd.endState > END_STATE_MARKERS.SHOW_NEW_GAME && !GameEnd.removeAdditionalEnd;
      this.opacity = (GameEnd.endState - END_STATE_MARKERS.SHOW_NEW_GAME) * 2;
      this.hasMoreCosmetics = GlyphAppearanceHandler.lockedSets.length > 0;
      this.selectedSetName = GlyphAppearanceHandler.chosenFromModal?.name ?? "Никакой (будет выбран случайно)";
    },
    startNewGame() {
      NG.startNewGame();
    },
    openSelectionModal() {
      Modal.cosmeticSetChoice.show();
    }
  }
};
</script>

<template>
  <div
    class="c-new-game-container"
    :style="style"
  >
    <h2>
      Перезапустить всю игру, но оставить Скрипты Автоматизатора, Пресеты Исследований, Секретные Темы, Секретные
      Достижения, Опции и Глифа-компаньона.
    </h2>
    <h3>Вы можете использовать кнопку справа-вверху чтобы посмотреть на игру такую, какая она сейчас.</h3>
    <div class="c-new-game-button-container">
      <button
        class="c-new-game-button"
        @click="startNewGame"
      >
        Начать сначала?
      </button>
    </div>
    <br>
    <h3 v-if="hasMoreCosmetics">
      За прохождение игры вы также разблокируете новый косметический набор Глифов на выбор. У вас будет возможность
      настроить их, когда вы вновь достигнете Реальности. Изменения исключительно визуальные и не дают никаких бонусов.
      <br>
      <button
        class="c-new-game-button"
        @click="openSelectionModal"
      >
        Выберите Косметический Набор
      </button>
      <br>
      <br>
      Выбранный Набор: {{ selectedSetName }}
    </h3>
    <h3 v-else>
      Вы отрыли все косметические наборы Глифов!
    </h3>
    <br>
    <h3>
      Вы также можете импортировать "спидран" чтобы начать игру сначала с дополнительной статистикой для целей спидрана.
    </h3>
  </div>
</template>

<style scoped>
.c-new-game-container {
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 9;
  justify-content: center;
  align-items: center;
  transform: translate(-50%, -50%);
  pointer-events: auto;
}

.t-s12 .c-new-game-container {
  color: white;
}

.c-new-game-button-container {
  display: flex;
  flex-direction: column;
  align-items: stretch;
}

.c-new-game-button {
  font-family: Typewriter;
  background: grey;
  border: black;
  border-radius: var(--var-border-radius, 0.5rem);
  margin-top: 1rem;
  padding: 1rem;
  cursor: pointer;
}
</style>
